import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Facebook, Youtube, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  async function subscribe(e) {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Subscribed. Welcome to the SSR family.");
      setEmail("");
    } catch { toast.error("Subscription failed"); }
    finally { setLoading(false); }
  }

  return (
    <footer className="mt-24 border-t border-border/60 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <Link to="/" className="group relative flex flex-col items-start leading-none">
            <span
              className="font-heading font-medium tracking-[-0.06em] text-3xl leading-none"
              style={{
                background: "linear-gradient(180deg, #FFFFFF 25%, rgba(37,99,235,0.9) 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textShadow: "0 0 22px rgba(37,99,235,0.5)",
              }}
            >
              SSR
            </span>
            <span className="mt-1 text-[10px] font-mono uppercase tracking-[0.32em] text-muted-foreground">Innovations</span>
          </Link>
          <p className="mt-3 text-sm text-muted-foreground max-w-sm leading-relaxed">
            Technology Meets Lifestyle. Premium accessories engineered for people who care about the details.
          </p>
          <form onSubmit={subscribe} className="mt-6 flex gap-2 max-w-sm">
            <input
              data-testid="footer-newsletter-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required
              placeholder="Your email"
              className="flex-1 h-11 px-4 rounded-full bg-secondary text-sm outline-none focus:ring-2 focus:ring-electric"
            />
            <button
              data-testid="footer-newsletter-submit"
              disabled={loading}
              className="h-11 px-4 rounded-full bg-electric text-white text-sm font-medium hover:bg-electric-600 transition-colors flex items-center gap-1 disabled:opacity-60"
            >
              Subscribe <ArrowRight className="w-4 h-4" />
            </button>
          </form>
        </div>
        <div>
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground mb-4">Shop</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/mobile-accessories" className="hover:text-electric transition-colors">Mobile Accessories</Link></li>
            <li><Link to="/lifestyle" className="hover:text-electric transition-colors">Lifestyle</Link></li>
            <li><Link to="/shop?best_seller=1" className="hover:text-electric transition-colors">Best Sellers</Link></li>
            <li><Link to="/shop?new=1" className="hover:text-electric transition-colors">New Arrivals</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-electric transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-electric transition-colors">Contact</Link></li>
            <li><Link to="/track-order" className="hover:text-electric transition-colors">Track Order</Link></li>
            <li><a href="#" className="hover:text-electric transition-colors">Careers</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-xs text-muted-foreground">© 2026 SSR Innovations. All Rights Reserved.</div>
          <div className="flex items-center gap-3">
            {[Instagram, Twitter, Facebook, Youtube].map((Icon, i) => (
              <a key={i} href="#" className="w-9 h-9 rounded-full border border-border hover:border-electric hover:text-electric flex items-center justify-center transition-colors">
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
